import MicrosoftIntegration from '../../../MicrosoftIntegration/MicrosoftIntegration';
import type { ConnectionCardProps } from '../../types';

const MicrosoftConnectionCard: React.FC<ConnectionCardProps> = () => {
  return <MicrosoftIntegration />;
};

export default MicrosoftConnectionCard;
